import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { CentroCusto } from "src/app/models/centrocusto.model";
import { EncarregadoCB } from "src/app/models/encarregadoCB.model";
import { Funcionario } from "src/app/models/funcionario.model";
import { AreaTecnicaService } from "src/app/pages/cadastros/areatecnica/areatecnica.service";
import { FuncionarioService } from "src/app/pages/cadastros/funcionario/funcionario.service";
import { IrregularidadeService } from "src/app/pages/cadastros/irregularidade/irregularidade.service";
import { Irregularidade, Prioridade } from "src/app/pages/domain/domain.model";
import {
  EquipamentoComboBoxViewModel,
  OSTipoViewModel,
} from "src/app/pages/domain/viewmodels.models";
import { FecharOSService } from "src/app/pages/os/fechar-os/fechar-os.service";
import { Photo } from "src/app/pages/os/fechar-os/photo.model";
import { CentroCustoService } from "src/app/services/centro.custo.service";
import { EquipamentoService } from "src/app/services/equipamento.service";
import { LocalService } from "src/app/services/local.service";
import { LogService } from "src/app/services/log.service";
import { OSService } from "src/app/services/os-service";
import { PrioridadeService } from "src/app/services/prioridade.service";
import { ImagemUtil } from "src/app/utils/Imagem.util";
import { Security } from "src/app/utils/security.util";
import { Util } from "src/app/utils/util.util";
import {
  APP_SETTINGS,
  SCAMP_API,
  SCAMP_API_RPT,
} from "src/environments/environment";
import Swal from "sweetalert2";
import { CommandResult } from "./../../pages/domain/commandResult";
import { FotoBase64ViewModel } from "./../../pages/domain/viewmodels.models";
import {
  CORES_STATUS_OS,
  STATUS_OS,
  IMAGENS_SATISFACAO,
  VALORES_SATISFACAO,
} from "src/app/shareds/constantes";

@Component({
  selector: "app-grid-OSs",
  templateUrl: "./grid-OSs.component.html",
  styleUrls: ["./grid-OSs.component.scss"],
})
export class GridOSsComponent implements OnInit {
  constructor(
    private osservice: OSService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private centroCustoService: CentroCustoService,
    private formBuilder: FormBuilder,
    private prioridadeService: PrioridadeService,
    private funcionarioService: FuncionarioService,
    private areasTecnicasService: AreaTecnicaService,
    private localService: LocalService,
    private equipamentoService: EquipamentoService,
    private fechamentoOSService: FecharOSService,
    private logService: LogService,
    private irregularidadeService: IrregularidadeService,
  ) {}

  @Input() public listaDeOSs: any[] = []; //
  @Input() public podeImprimir: boolean = false; // Se false botão imprimir OS fica disabilitado
  @Input() public heightGridPx: number; // Altura da Grid em pixels
  @Input() public modoEdicao: boolean = false;

  @ViewChild("imprimirEvidenciaDeFotos") imprimirEvidenciaDeFotos: ElementRef;

  osCompleta: any = null;
  urlPhotoSelecionada = "";

  bgStatus: string[] = CORES_STATUS_OS;
  statusOS: string[] = STATUS_OS;

  markedForPrinting: OSTipoViewModel[] = [];
  countMarked: number = 0;
  isPrintingOSs: boolean = false;
  allMarkeds: boolean = false;

  imprimindoOS: boolean = false;
  imprimindoOSId: number = 0;
  public sortColumn = "id"; // coluna usada para ordenar o grid
  public sortType = "desc"; // tipo de ordenação usada
  centrosDeCusto: CentroCusto[] = [];

  form: FormGroup = null;
  prioridades: Prioridade[] = [];
  engenheiros: Funcionario[] = [];
  encarregados: EncarregadoCB[] = [];
  areasTecnicas: any[] = [];
  public locaisPorNivel: any[] = [];
  equipamentos: EquipamentoComboBoxViewModel[] = [];

  files: File[] = []; // armazena os arquivo de fotos
  filesAntes: File[] = [];
  previewsPhotos: Photo[] = []; // armazena as photos em base 64 para exibição
  previewsPhotosAntes: Photo[] = []; // armazena as photos em base 64 para exibição
  previewPhotoSelecionada: Photo; // dataUrl (base 64) da foto clicada
  photoForm: FormGroup;
  isLoadingRegistroFotografico: boolean = false;

  possiveisColaboradoresListaGrid: any[] = [];
  possiveisMateriaisListaGrid: any[] = [];
  irregularidades: Irregularidade[] = [];
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  public imagens_satisfacao: string[] = IMAGENS_SATISFACAO;
  public valores_satisfacao: string[] = VALORES_SATISFACAO;

  showModalLogAvaliacao: boolean = null;

  validacoes: {
    servicoRealizado: string;
    dataHoraInicioExec: string;
    dataHoraFimExec: string;
    datasColaboradoresOK: boolean; //?
    reset(): void;
    valid(): boolean;
  } = {
    servicoRealizado: "",
    dataHoraInicioExec: "",
    dataHoraFimExec: "",
    datasColaboradoresOK: true, //?
    reset(): void {
      this.servicoRealizado = "";
      this.dataHoraInicioExec = "";
      this.dataHoraFimExec = "";
      this.datasColaboradoresOK = true; //?
    },
    valid(): boolean {
      return (
        this.servicoRealizado === "" &&
        this.dataHoraInicioExec === "" &&
        this.dataHoraFimExec === "" &&
        this.datasColaboradoresOK == true //?
      );
    },
  };

  ngOnInit() {
    this.resetForm();
    this.getPrioridades();
    this.getAreasTecnicas();
    this.resetPhotoForm();
    this.getIrregularidades();

    this.centroCustoService.getCentrosCustos().subscribe(
      (response: CentroCusto[]) => {
        this.centrosDeCusto = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter lista de Centros Custos");
      },
    );
  }

  resetForm() {
    this.form = this.formBuilder.group({
      osId: [""],
      spvId: [""],
      ptId: [""],
      spvAprovadoId: [""],
      requisitante: ["", Validators.required],
      contato: ["", Validators.required],
      servico: ["", Validators.required],
      centroCustoId: ["", Validators.required],
      prioridadeId: ["", Validators.required],
      observacoesGerais: [""],
      areaRestrita: [null],
      fimDeSemana: [""],
      engenheiroResponsavelId: [""],
      encarregadoResponsavelId: [""],
      areaTecnicaId: [""],
      localId: [""],
      equipamentoId: [""],
      osFechamentoId: [""],
      servicoRealizado: [null],
      dataHoraInicioExec: [null],
      dataHoraFimExec: [null],
      datalistCentroCustos: ["", Validators.required],
      tipoOSFilha: [null],
      irregularidadeId: [""],
      localizacao: [""],
    });
  }

  resetPhotoForm() {
    this.photoForm = this.formBuilder.group({
      photo: ["", [Validators.required]],
    });
  }

  private getPrioridades() {
    this.prioridadeService.getAll().subscribe((response: Prioridade[]) => {
      this.prioridades = response;
    });
  }

  getIrregularidades() {
    this.irregularidadeService
      .getAll()
      .subscribe((response: Irregularidade[]) => {
        this.irregularidades = response;
      });
  }

  public getAreasTecnicas() {
    this.areasTecnicasService.list().subscribe((response: any) => {
      this.areasTecnicas = response;
    });
  }

  public getLocais(grupoLocalNivel1Id: number) {
    this.locaisPorNivel = [];
    this.localService
      .getLocaisByGroupLevelOne(grupoLocalNivel1Id)
      .subscribe((response) => {
        this.locaisPorNivel = response;

        if (this.locaisPorNivel.length == 1) {
          this.form.get("localId").setValue(this.locaisPorNivel[0].id);
          this.getEquipamentoPorLocalId(this.locaisPorNivel[0].id);
        }
      });
  }

  getEquipamentoPorLocalId(localId: number, equipamentoId: number = null) {
    if (Number(localId) === 0) {
      this.equipamentos = [];
      return;
    }

    this.equipamentoService.getEquipamentosPorLocalId(localId).subscribe(
      (response) => {
        this.equipamentos = response;

        if (equipamentoId != null && equipamentoId != 0) {
          this.form.get("equipamentoId").setValue(equipamentoId);
        } else {
          if (this.modoEdicao) {
            this.form.get("equipamentoId").setValue("");
          }
        }
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter Equipamentos");
      },
    );
  }

  submit(modal: any) {
    this.validaDadosRealizacao();

    if (this.validacoes.valid()) {
      this.osCompleta.uploadPhotos = [];

      let count = 0;
      if (this.files.length > 0) {
        for (const f of this.files) {
          count++;
          this.osCompleta.uploadPhotos.push({
            id: 0,
            arquivoNomeOriginal: f.name,
            arquivoNome: Util.getArquivoNome(this.osCompleta.osId, count),
            osFechamentoId: this.osCompleta.osFechamentoId,
            spvId: null,
          });
        }
      }

      this.form.get("tipoOSFilha").setValue(this.osCompleta.tipoOSFilha);

      this.osservice
        .editarOS(this.form.value, this.osCompleta)
        .subscribe((response) => {
          if (response.success == true) {
            this.toastr.success(response.message);
            this.modalService.dismissAll();

            let os = this.listaDeOSs.find((t) => t.id == this.osCompleta.osId);

            os.servicoSolicitado = this.form.get("servico").value;
            os.servicoRealizado = this.form.get("servicoRealizado").value;
            os.dataHoraFimExec = this.form.get("dataHoraInicioExec").value;
            os.local = this.locaisPorNivel.find(
              (t) => t.id == Number(this.form.get("localId").value),
            ).nome;
            os.areaTecnica = this.areasTecnicas.find(
              (t) => t.id == Number(this.form.get("areaTecnicaId").value),
            ).nome;
            os.prioridadeStr = this.prioridades.find(
              (t) => t.id == Number(this.form.get("prioridadeId").value),
            ).descricao;
            os.tipoOSStr = this.osCompleta.tipoOSStr;
            os.irregularidadeId =
              this.form.get("irregularidadeId").value == ""
                ? null
                : Number(this.form.get("irregularidadeId").value);

            if (Number(this.form.get("irregularidadeId").value) > 0) {
              os.irregularidadeDescricao = this.irregularidades.find(
                (x) => x.id == Number(this.form.get("irregularidadeId").value),
              ).descricao;
            }

            // Registra Log de alteração

            this.logService
              .post({
                id: 0,
                dataHora: Util.formatarDataComHoraEnUS(new Date()),
                osId: this.osCompleta.osId,
                usuarioId: Security.getUser().id,
              })
              .subscribe(() => {});

            this.fechamentoOSService
              .uploadPhotos(this.files, this.osCompleta.uploadPhotos)
              .subscribe(
                () => {},
                (exception: any) => {
                  this.showErrorExecption(exception);
                },
              );
          } else {
            this.toastr.error(response.message);
          }
        });
    }
  }

  markForPrinting(id: number, tipoOSFilha: number) {
    const alreadyMarked: boolean = this.markedForPrinting.some(
      (t) => t.oSId == id,
    );
    const relatedOS = this.listaDeOSs.find((t) => t.id == id);

    if (alreadyMarked) {
      this.markedForPrinting = this.markedForPrinting.filter(
        (t) => t.oSId != id,
      );
      relatedOS.marked = false;
    } else {
      this.markedForPrinting.push({
        oSId: id,
        tipoOSFilha: tipoOSFilha,
        fileNamePdf: "",
        imprimirEvidenciaDeFotos: "",
      });

      relatedOS.marked = true;
    }

    this.countMarked = this.markedForPrinting.length;
  }

  markDesmarkAllToPriting() {
    this.markedForPrinting = [];

    this.allMarkeds = !this.allMarkeds;

    this.listaDeOSs.map((t) => {
      t.marked = this.allMarkeds;
    });

    if (this.allMarkeds == true) {
      this.listaDeOSs.map((t) => {
        this.markedForPrinting.push({
          oSId: t.id,
          tipoOSFilha: t.tipoOSFilha,
          fileNamePdf: "",
          imprimirEvidenciaDeFotos: "",
        });
      });
    }

    this.countMarked = this.markedForPrinting.length;
  }

  printingOSs() {
    this.isPrintingOSs = true;

    this.markedForPrinting.map((t) => {
      t.imprimirEvidenciaDeFotos = this.imprimirEvidenciaDeFotos.nativeElement
        .checked
        ? "S"
        : "N";
    });

    this.osservice.imprimirOSMerge(this.markedForPrinting).subscribe(
      (response) => {
        if (response.success === true) {
          if (response.nenhumResultado === false) {
            window.open(
              `${SCAMP_API_RPT.root}${response.pathRpt}`,
              "_blank",
              "width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no",
            );
          } else {
            this.toastr.warning(response.msgErro);
          }
        } else {
          this.toastr.error(response.msgErro);
        }
        this.isPrintingOSs = false;
      },
      (err: any) => {
        this.toastr.error(
          "Não foi possível se conectar ao servidor de relatórios",
          "Erro de Conexão",
        );
        this.isPrintingOSs = false;
      },
    );
  }

  reimprimirOS(id: number, tipoOSFilha: number) {
    this.imprimindoOS = true;
    this.imprimindoOSId = id;

    this.osservice
      .imprimirOS(
        id,
        tipoOSFilha,
        this.imprimirEvidenciaDeFotos.nativeElement.checked ? "S" : "N",
      )
      .subscribe(
        (response) => {
          if (response.success === true) {
            if (response.nenhumResultado === false) {
              window.open(
                `${SCAMP_API_RPT.root}${response.pathRpt}`,
                "_blank",
                "width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no",
              );
            } else {
              this.toastr.warning(response.msgErro);
            }
          } else {
            this.toastr.error(response.msgErro);
          }
          this.imprimindoOS = false;
          this.imprimindoOSId = 0;
        },
        (err: any) => {
          this.toastr.error(
            "Não foi possível se conectar ao servidor de relatórios",
            "Erro de Conexão",
          );
          this.imprimindoOS = false;
          this.imprimindoOSId = 0;
        },
      );
  }

  reset() {
    this.validacoes.reset();
    this.resetPhotoForm();
    this.files = [];
    this.filesAntes = [];
    this.previewsPhotos = [];
    this.previewsPhotosAntes = [];
    this.previewPhotoSelecionada = null;
  }

  validaDadosRealizacao() {
    this.validacoes.reset();

    this.validacoes.datasColaboradoresOK = this.checkDatasColaboradores(); //?

    if (this.osCompleta.status == 3) {
      // OS Fechada
      const servicoRealizado = this.form.get("servicoRealizado").value;
      const dataHoraInicioExec = this.form.get("dataHoraInicioExec").value;
      const dataHoraFimExec = this.form.get("dataHoraFimExec").value;

      this.validacoes.reset();

      if (servicoRealizado === "") {
        this.validacoes.servicoRealizado =
          "O Serviço Realizado deve ser informado";
      }
      if (dataHoraInicioExec === "") {
        this.validacoes.dataHoraInicioExec =
          "Informe a Data Hora Inicio da Execução";
      }
      if (dataHoraFimExec === "") {
        this.validacoes.dataHoraFimExec = "Informe a Data Hora Fim da Execução";
      }
    }
  }

  getById(osid: number, spvId: number, modalDetalhesSpv: any) {
    this.reset();

    console.log(":? ", osid, spvId);

    this.osservice.getOSCompleta(osid, spvId).subscribe(
      (response) => {
        this.osCompleta = response;
        console.log("!!", this.osCompleta);
        this.possiveisColaboradoresListaGrid =
          this.osCompleta.possiveisColaboradores;
        //console.log(this.osCompleta)

        this.form.patchValue({
          osId: response.osId,
          spvId: response.spvCompleto.spvId,
          ptId: response.spvCompleto.ptId,
          spvAprovadoId: response.spvCompleto.spvAprovadoId,
          servico: response.spvCompleto.servico,
          centroCustoId: response.spvCompleto.centroCustoId,
          prioridadeId: response.spvCompleto.prioridadeId,
          contato: response.spvCompleto.contato,
          requisitante: response.spvCompleto.requisitante,
          statusStr: response.spvCompleto.statusStr,
          observacoesGerais: response.spvCompleto.observacoesGerais,
          areaRestrita: response.spvCompleto.areaRestrita,
          fimDeSemana:
            response.spvCompleto.fimDeSemana == null
              ? ""
              : response.spvCompleto.fimDeSemana,
          areaTecnicaId: response.spvCompleto.areaTecnicaId,
          localId: response.spvCompleto.localId,
          servicoRealizado: response.servicoRealizado,
          dataHoraInicioExec: response.dataHoraInicioExec,
          dataHoraFimExec: response.dataHoraFimExec,
          osFechamentoId: response.osFechamentoId,
          datalistCentroCustos: response.spvCompleto.centroCusto,
          irregularidadeId:
            response.irregularidadeId == null ? "" : response.irregularidadeId,
          localizacao:
            response.spvCompleto.localizacao == null
              ? ""
              : response.spvCompleto.localizacao,
        });

        if (this.osCompleta.tipoOSFilha == 1) {
          this.form.get("requisitante").disable();
          this.form.get("observacoesGerais").disable();
          this.form.get("datalistCentroCustos").disable();
          this.form.get("areaRestrita").disable();
          this.form.get("fimDeSemana").disable();
          this.form.get("contato").disable();
        } else {
          this.form.get("requisitante").enable();
          this.form.get("observacoesGerais").enable();
          this.form.get("datalistCentroCustos").enable();
          this.form.get("areaRestrita").enable();
          this.form.get("fimDeSemana").enable();
          this.form.get("contato").enable();
        }

        this.funcionarioService
          .getEngenheirosPorEmpreiteira(response.spvCompleto.empreiteiraId)
          .subscribe((enghrs) => {
            this.engenheiros = enghrs;
            this.form
              .get("engenheiroResponsavelId")
              .setValue(
                response.spvCompleto.engenheiroResponsavelId == null
                  ? ""
                  : response.spvCompleto.engenheiroResponsavelId,
              );
          });

        this.funcionarioService
          .getEncarregadosPorEmpreiteira(response.spvCompleto.empreiteiraId)
          .subscribe((encs) => {
            this.encarregados = encs;
            this.form
              .get("encarregadoResponsavelId")
              .setValue(
                response.spvCompleto.encarregadoResponsavelId == null
                  ? ""
                  : response.spvCompleto.encarregadoResponsavelId,
              );
          });

        this.localService
          .getLocaisByGroupLevelOne(response.spvCompleto.grupoLocalNivel1Id)
          .subscribe((locais) => {
            this.locaisPorNivel = locais;
            this.form.get("localId").setValue(response.spvCompleto.localId);
            this.getEquipamentoPorLocalId(
              response.spvCompleto.localId,
              response.spvCompleto.equipamentoId,
            );
          });

        this.isLoadingRegistroFotografico = true;

        this.fechamentoOSService
          .getArrayFotosBase64(this.osCompleta.uploadPhotos)
          .subscribe((responseFotos: FotoBase64ViewModel[]) => {
            responseFotos.forEach((foto) => {
              this.handleFile(
                [].concat(
                  Util.dataURLtoFile(foto.base64String, foto.arquivoNome),
                ),
                false,
              );
              this.previewsPhotos.push({
                dataUrl: foto.base64String,
                name: foto.arquivoNome,
              });
            });
            this.isLoadingRegistroFotografico = false;
          });

        this.fechamentoOSService
          .getArrayFotosBase64(this.osCompleta.fotosAntes)
          .subscribe((responseFotos: FotoBase64ViewModel[]) => {
            responseFotos.forEach((foto) => {
              this.handleFileAntes(
                [].concat(
                  Util.dataURLtoFile(foto.base64String, foto.arquivoNome),
                ),
                false,
              );
              this.previewsPhotosAntes.push({
                dataUrl: foto.base64String,
                name: foto.arquivoNome,
              });
            });
            this.isLoadingRegistroFotografico = false;
          });

        this.modalService.open(modalDetalhesSpv, {
          windowClass: "xlModal",
          backdrop: "static",
        });
      },
      (err: any) => {
        this.toastr.error(
          `Ocorreu um erro no servidor.<br /><br /> ${err.error}`,
        );
      },
    );
  }

  getUrlPhoto(arquivoNome: string) {
    return `${SCAMP_API.pathDownloadPhoto}/${arquivoNome}`;
  }

  /* openModalExibePhoto2(modal, arquivoNome: string) {
    this.urlPhotoSelecionada = this.getUrlPhoto(arquivoNome);
    this.modalService.open(modal, { windowClass: 'zoomPhotoModal', backdrop: 'static' });
  } */

  sortTable(sortColumnCurrent: string) {
    if (sortColumnCurrent === this.sortColumn) {
      if (this.sortType === "asc") {
        this.sortType = "desc";
      } else {
        this.sortType = "asc";
      }
    } else {
      this.sortType = "asc";
      this.sortColumn = sortColumnCurrent;
    }

    if (this.sortType == "asc") {
      this.listaDeOSs.sort((item1, item2) => {
        if (
          String(item1[this.sortColumn]).toLowerCase() <
          String(item2[this.sortColumn]).toLowerCase()
        )
          return -1;
        if (
          String(item1[this.sortColumn]).toLowerCase() >
          String(item2[this.sortColumn]).toLowerCase()
        )
          return 1;

        return 0;
      });
    } else {
      this.listaDeOSs.sort((item1, item2) => {
        if (
          String(item1[this.sortColumn]).toLowerCase() >
          String(item2[this.sortColumn]).toLowerCase()
        )
          return -1;
        if (
          String(item1[this.sortColumn]).toLowerCase() <
          String(item2[this.sortColumn]).toLowerCase()
        )
          return 1;

        return 0;
      });
    }
  }

  limparDataListCentroCustos() {
    this.form.get("datalistCentroCustos").setValue("");
  }

  changeDataListCentroCustos(value: string) {
    let item;
    if (value != "") {
      item = this.centrosDeCusto.filter((t) =>
        t.nome.toLowerCase().includes(value.toLowerCase()),
      )[0];
    }
    if (item != undefined) {
      this.form.get("datalistCentroCustos").setValue(item.nome);
      this.form.get("centroCustoId").setValue(item.id);
    } else {
      this.form.get("datalistCentroCustos").setValue("");
      this.form.get("centroCustoId").setValue("");
    }
  }

  /* *** Trata adição e remoção de Colaboradores   *** */
  openModalColaboradores(modal) {
    this.modalService.open(modal, {
      windowClass: "xlModal",
      backdrop: "static",
    });
  }

  selectColaborador(id: number) {
    this.osCompleta.possiveisColaboradores.forEach((f) => {
      if (f.id === id) {
        f.marcado = !f.marcado;
      }
    });
  }

  adicionarColaboradores(id: number) {
    this.osCompleta.possiveisColaboradores.forEach((f) => {
      if (f.marcado) {
        f.marcado = false;
        const newColaborador = { ...f, dataHoraInicio: "", dataHoraFim: "" };
        this.osCompleta.spvCompleto.colaboradores.push(newColaborador);
      }
    });

    // reordena pelo nome os colaboradores após a inserção
    this.osCompleta.spvCompleto.colaboradores.sort((f1, f2) => {
      if (f1.nome < f2.nome) {
        return -1;
      }
      if (f1.nome > f2.nome) {
        return 1;
      }
      return 0;
    });
  }

  removerColaborador(i: number) {
    this.osCompleta.spvCompleto.colaboradores.splice(i, 1);

    // reordena pelo nome os funcionário após o retorno
    this.osCompleta.possiveisColaboradores.sort((f1, f2) => {
      if (f1.nome < f2.nome) {
        return -1;
      }
      if (f1.nome > f2.nome) {
        return 1;
      }
      return 0;
    });

    // reordena pelo nome os funcionário após o retorno
    this.possiveisColaboradoresListaGrid.sort((f1, f2) => {
      if (f1.nome < f2.nome) {
        return -1;
      }
      if (f1.nome > f2.nome) {
        return 1;
      }
      return 0;
    });
  }

  /* *** Trata adição e remoção de Irregularidades   *** */

  openModalIrregularidades(modal) {
    this.modalService.open(modal, {
      windowClass: "xlModal",
      backdrop: "static",
    });
  }

  selectIrregularidade(id: number) {
    this.osCompleta.possiveisIrregularidades.forEach((i) => {
      if (i.id === id) {
        i.marcado = !i.marcado;
      }
    });
  }

  adicionarIrregularidades(id: number) {
    this.osCompleta.possiveisIrregularidades.forEach((i) => {
      if (i.marcado) {
        i.marcado = false;
        this.osCompleta.irregularidades.push(i);
        this.osCompleta.possiveisIrregularidades =
          this.osCompleta.possiveisIrregularidades.filter(
            (i2) => i2.id !== i.id,
          );
      }
    });

    // reordena pelo nome os colaboradores após a inserção
    this.osCompleta.irregularidades.sort((i1, i2) => {
      if (i1.nome < i2.nome) {
        return -1;
      }
      if (i1.nome > i2.nome) {
        return 1;
      }
      return 0;
    });
  }

  removerIrregularidade(i: any) {
    this.osCompleta.possiveisIrregularidades.push(i);
    const irregularidadeId = i.id;
    const osFechamentoId = this.osCompleta.osFechamentoId;

    this.osCompleta.irregularidades = this.osCompleta.irregularidades.filter(
      (i2) => i2.id !== i.id,
    );

    // reordena pelo nome os funcionário após o retorno
    this.osCompleta.possiveisIrregularidades.sort((i1, i2) => {
      if (i1.nome < i2.nome) {
        return -1;
      }
      if (i1.nome > i2.nome) {
        return 1;
      }
      return 0;
    });

    if (osFechamentoId !== undefined) {
      this.fechamentoOSService
        .removerOSFechamentoIrregularidade(irregularidadeId, osFechamentoId)
        .subscribe((response) => {});
    }
  }

  /* *** Trata adição e remoção de Fotos   *** */

  openModalExibePhoto(modal, pview) {
    this.previewPhotoSelecionada = pview;
    this.modalService.open(modal, {
      windowClass: "zoomPhotoModal",
      backdrop: "static",
    });
  }

  handleFile(newArrayfiles: File[], addPreviewsPhotos: boolean = true) {
    if (newArrayfiles.length === 0) {
      return;
    }

    let msgErroArquivo = "";
    let qtdErrosArquivo = 0;
    let arquivoValido = true;
    var pattern = /image-*/;

    for (const f of newArrayfiles) {
      if (!f.type.match(pattern)) {
        arquivoValido = false;
        qtdErrosArquivo++;
        msgErroArquivo += `${f.name} - [${f.type}] <br />`;
        msgErroArquivo += "Não é um arquivo de imagem e não foi adicionado";
      }

      if (arquivoValido) {
        if (f.name.length > 100) {
          arquivoValido = false;
          qtdErrosArquivo++;
          msgErroArquivo += `${f.name} - [${f.name.length} caracteres] <br />`;
          msgErroArquivo = `O nome do arquivo <br /><br /><span class="fb">${msgErroArquivo}</span><br />que você está tentando inserir é muito longo e não foi adicionado`;
        }
      }

      if (arquivoValido) {
        const tamanhoArquivo = Number((f.size / 1024 / 1024).toFixed(2));

        if (tamanhoArquivo > APP_SETTINGS.tamanhoLimiteUploadArquivo) {
          arquivoValido = false;
          qtdErrosArquivo++;
          msgErroArquivo += `${f.name}  [${tamanhoArquivo}MB] <br />`;
          msgErroArquivo = `O arquivo <br /><br /><span class="fb">${msgErroArquivo}</span><br />que você está tentando inserir ultrapassa o limite de `;
          msgErroArquivo += `<span class="fb">${APP_SETTINGS.tamanhoLimiteUploadArquivo} MB</span> permito para uploads e não foi adicionado.`;
        }
      }

      if (arquivoValido) {
        if (!this.files.some((file) => file.name === f.name)) {
          this.files.push(f);

          if (addPreviewsPhotos) {
            this.isLoadingRegistroFotografico = true;
            const reader = new FileReader();
            reader.onload = (event: any) => {
              this.previewsPhotos.push({
                dataUrl: event.target.result,
                name: f.name,
              });
              this.isLoadingRegistroFotografico = true;
            };
            reader.readAsDataURL(f);
          }
        }
      }
    }

    this.photoForm.get("photo").setValue("");

    if (qtdErrosArquivo > 0) {
      Swal({
        position: "center",
        html: msgErroArquivo,
        type: null,
        animation: false,
        customClass: "animated fadeInDown",
        width: "550px",
        heightAuto: false,
        background: "#f7b924",
        showCloseButton: true,
        showConfirmButton: false,
      });
    }
  }

  handleFileAntes(files: File[], addPreviewsPhotos: boolean = true) {
    ImagemUtil.handleFile(
      files,
      this.filesAntes,
      this.previewsPhotosAntes,
      this.isLoadingRegistroFotografico,
      addPreviewsPhotos,
    );
  }

  removerPhoto(name: string) {
    let photoPersistida = Array.from<any>(this.osCompleta.uploadPhotos).find(
      (t) => t.arquivoNome == name,
    );

    if (photoPersistida) {
      this.questionDelete(photoPersistida.id, name);
      return;
    }

    this.previewsPhotos = this.previewsPhotos.filter(
      (photo: Photo) => photo.name !== name,
    );
    this.files = this.files.filter((f) => f.name !== name);
  }

  public questionDelete(uploadPhotoId: number, name: string) {
    Swal({
      title: "Excluir",
      text: "Deseja excluir o arquivo selecionado?",
      type: "question",
      showCancelButton: true,
      cancelButtonText: "Não",
      showConfirmButton: true,
      confirmButtonText: "Sim",
      cancelButtonColor: "#d33",
      focusCancel: true,
    }).then((result) => {
      if (result.value) {
        this.deletePhoto(uploadPhotoId, name);
      }
    });
  }

  private deletePhoto(uploadPhotoId: number, name: string): void {
    this.osservice
      .removerUploadPhoto(uploadPhotoId)
      .subscribe((response: CommandResult) => {
        if (response.success == false) {
          this.toastr.error(response.message);
        } else {
          this.toastr.success(response.message);
          this.previewsPhotos = this.previewsPhotos.filter(
            (photo: Photo) => photo.name !== name,
          );
          this.files = this.files.filter((f) => f.name !== name);
        }
      });
  }

  /* *** Trata adição e remoção de Materiais   *** */

  openModalMateriais(modal) {
    this.modalService.open(modal, {
      windowClass: "xlModal",
      backdrop: "static",
    });
  }

  selectMateriais(materialId: number) {
    this.osCompleta.possiveisMateriais.forEach((i) => {
      if (i.materialId === materialId) {
        i.marcado = !i.marcado;
      }
    });
  }

  adicionarMateriais() {
    let totalMarcados = 0;
    this.osCompleta.possiveisMateriais.forEach((i) => {
      if (i.marcado) {
        totalMarcados++;
        const quantidade = <HTMLInputElement>(
          document.getElementById(i.materialId)
        );

        if (quantidade.value == "") {
          i.touched = true;
          return;
        }

        i.marcado = false;
        i.touched = false;
        i.quantidade = quantidade.value;
        this.osCompleta.materiaisUsado.push(i);

        this.osCompleta.possiveisMateriais =
          this.osCompleta.possiveisMateriais.filter(
            (i2) => i2.materialId !== i.materialId,
          );
        this.possiveisMateriaisListaGrid =
          this.possiveisMateriaisListaGrid.filter(
            (i2) => i2.materialId !== i.materialId,
          );
      }
    });

    if (totalMarcados > 0) {
      // reordena pelo nome os materiais após a inserção
      this.osCompleta.materiaisUsado.sort((i1, i2) => {
        if (i1.descricao < i2.descricao) {
          return -1;
        }
        if (i1.descricao > i2.descricao) {
          return 1;
        }
        return 0;
      });
    } else {
      this.toastr.warning(
        "Selecione ao menos um material na grid 'Materiais disponíveis'",
      );
    }
  }

  removerMateriais(i: any) {
    i.marcado = false;
    i.touched = false;
    i.quantidade = 0;

    this.osCompleta.possiveisMateriais.push(i);
    this.possiveisMateriaisListaGrid.push(i);
    const materiaisId = i.materialId;
    const osFechamentoId = this.osCompleta.osFechamentoId;

    this.osCompleta.materiaisUsado = this.osCompleta.materiaisUsado.filter(
      (i2) => i2.materialId !== i.materialId,
    );

    // reordena pelo nome os materiais após o retorno
    this.osCompleta.possiveisMateriais.sort((i1, i2) => {
      if (i1.descricao < i2.descricao) {
        return -1;
      }
      if (i1.descricao > i2.descricao) {
        return 1;
      }
      return 0;
    });

    // reordena pelo nome os funcionário após o retorno
    this.possiveisMateriaisListaGrid.sort((f1, f2) => {
      if (f1.nome < f2.nome) {
        return -1;
      }
      if (f1.nome > f2.nome) {
        return 1;
      }
      return 0;
    });

    if (osFechamentoId !== undefined) {
      this.fechamentoOSService
        .removerOSFechamentoMovOrdemMaterial(materiaisId, osFechamentoId)
        .subscribe((response) => {});
    }
  }

  limparDataListFuncionarios() {
    (
      document.getElementById("datalistFuncionarios") as HTMLInputElement
    ).value = "";
    this.possiveisColaboradoresListaGrid =
      this.osCompleta.possiveisColaboradores;
  }

  changeDataListFuncionarios(value: string) {
    if (value != "") {
      this.possiveisColaboradoresListaGrid =
        this.osCompleta.possiveisColaboradores.filter(
          (t) =>
            t.nome.toLowerCase().includes(value.toLowerCase()) ||
            t.matricula.toLowerCase().includes(value.toLocaleLowerCase()),
        );
    }
  }

  limparDataListMateriais() {
    (document.getElementById("datalistMateriais") as HTMLInputElement).value =
      "";
    this.possiveisMateriaisListaGrid = this.osCompleta.possiveisMateriais;
  }

  changeDataListMateriais(value: string) {
    if (value != "") {
      this.possiveisMateriaisListaGrid =
        this.osCompleta.possiveisMateriais.filter(
          (t) =>
            t.descricao.toLowerCase().includes(value.toLowerCase()) ||
            t.codigo.toLowerCase().includes(value.toLocaleLowerCase()) ||
            t.tipoMaterialDescricao
              .toLowerCase()
              .includes(value.toLocaleLowerCase()),
        );
    }
  }

  openModalLog(modal) {
    this.modalService.open(modal, {
      windowClass: "smModal",
      backdrop: "static",
    });
  }

  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) {
      msg = "A aplicação não conseguiu se conectar ao Servidor";
    }
    if (Number(exception.status) === 500) {
      msg = "O Servidor gerou um erro de processamento";
    }
    this.toastr.error(
      `<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`,
    );
  }

  public checkDatasColaboradores() {
    let valid = true;

    if (this.osCompleta.osFechamentoId != null) {
      this.osCompleta.spvCompleto.colaboradores.forEach((c) => {
        valid = valid && !!c.dataHoraInicio;
        valid = valid && !!c.dataHoraFim;
      });
    }

    return valid;
  }

  public confirmarColaboradores(c: any) {
    let valid = true;

    let i = 0;

    if (this.osCompleta.osFechamentoId != null) {
      this.osCompleta.spvCompleto.colaboradores.forEach((c) => {
        const inputdhInicio = <HTMLInputElement>(
          document.getElementById("data-hi-colaborador" + i)
        );
        const inputdhFinal = <HTMLInputElement>(
          document.getElementById("data-hf-colaborador" + i)
        );

        inputdhInicio.classList.remove("h-error");
        inputdhFinal.classList.remove("h-error");

        if (inputdhInicio.parentNode.parentNode.childNodes.item(1)) {
          inputdhInicio.parentNode.parentNode.childNodes.item(1).remove();
        }

        if (inputdhFinal.parentNode.parentNode.childNodes.item(1)) {
          inputdhFinal.parentNode.parentNode.childNodes.item(1).remove();
        }

        const dhInicio = inputdhInicio.value;
        const dhFinal = inputdhFinal.value;

        const NENHUMA_DATA_INFORMADA: boolean = !dhInicio && !dhFinal;
        const ALGUMA_DATA_INFORMADA: boolean = !NENHUMA_DATA_INFORMADA;

        if (ALGUMA_DATA_INFORMADA) {
          const AMBAS_DATAS_INFORMADAS = dhInicio && dhFinal;

          if (AMBAS_DATAS_INFORMADAS) {
            const dataInicio = new Date(dhInicio);
            const dataFim = new Date(dhFinal);

            if (dataFim.getTime() < dataInicio.getTime()) {
              let span = document.createElement("span");
              span.classList.add("txt-danger-fb");
              span.innerHTML =
                "Data/Hora final deve ser maior que Data/Hora inicial";
              inputdhFinal.classList.add("h-error");
              (<HTMLElement>inputdhFinal.parentNode).insertAdjacentElement(
                "afterend",
                span,
              );
              valid = false;
            } else {
              c.dataHoraInicio = dhInicio;
              c.dataHoraFim = dhFinal;
            }
          } else {
            if (!dhInicio) {
              let span = document.createElement("span");
              span.classList.add("txt-danger-fb");
              span.innerHTML = "informe a data/hora início";
              inputdhInicio.classList.add("h-error");
              (<HTMLElement>inputdhInicio.parentNode).insertAdjacentElement(
                "afterend",
                span,
              );

              valid = false;
            }

            if (!dhFinal) {
              let span = document.createElement("span");
              span.classList.add("txt-danger-fb");
              span.innerHTML = "informe a data/hora final";
              inputdhFinal.classList.add("h-error");
              (<HTMLElement>inputdhFinal.parentNode).insertAdjacentElement(
                "afterend",
                span,
              );

              valid = false;
            }
          }
        } else {
          c.dataHoraInicio = "";
          c.dataHoraFim = "";
        }
        i++;
      });
    }

    if (valid) {
      c("Close click");
    }
  }

  closeModalColaboradores(c: any) {}

  clearInputDataHiColaborador(prefixoIdDataColaborador, i) {
    const inputdata = <HTMLInputElement>(
      document.getElementById(prefixoIdDataColaborador + i)
    );

    inputdata.value = "";
  }

  showModalReabrirOS(osid: number, modalReaberturaOS: any) {
    console.log(osid);
    this.modalService.open(modalReaberturaOS, {
      windowClass: "lgModal",
      backdrop: "static",
    });
  }

  confirmarReaberturaOS(osId: number, justificativaAbertura: string, c: any) {
    const statusOSAberta: number = 1;

    const logAvaliacao = {
      osid: osId,
      usuarioId: Security.getUser().id,
      statusOS: statusOSAberta, // OS Aberta
      observacaoAvaliacao: justificativaAbertura,
    };

    this.logService.postAvaliacao(logAvaliacao).subscribe(() => {
      this.osservice.setStatusOSAberta(osId).subscribe(() => {
        this.osCompleta.status = statusOSAberta;
        c("Close click");
      });
    });
  }

  setShowModalLogAvaliacao() {
    this.showModalLogAvaliacao = true;
  }

  changeShowModal() {
    this.showModalLogAvaliacao = false;
  }
}
